import React, { PureComponent } from 'react'
import { Table, Divider, Form, Input, Col, Button, message, Modal } from 'antd'
import uuid from 'uuid/v4'
import DataModal from './modal'
import api from './../../api'
import styles from './style.module.less'
import IUser from '../../models/user'
import PasswordModal from './password'
import ImageView from './../../components/imageView'
const { confirm } = Modal

class UserPage extends PureComponent {
  constructor(props: any) {
    super(props)
  }
  state = {
    loading: true,
    list: [],
    form: {
      pageSize: 15,
      page: 1,
      keyword: '',
      type: '员工'
    },
    total: 0,
    modalOpen: false,
    modalTitle: '',
    updateItem: {} as IUser,
    passwordModalOpen: false
  }
  columns = [
    {
      title: '真实姓名',
      dataIndex: 'realName',
      key: 'realName',
      align: 'center' as 'center'
    },
    {
      title: '手机',
      dataIndex: 'phone',
      key: 'phone',
      align: 'center' as 'center'
    },
    {
      title: '操作',
      key: 'action',
      align: 'center' as 'center',
      width: 300,
      render: (text: any, record: IUser) => (
        <span>
          <a
            onClick={() => {
              this.bingWeapp(record)
            }}
          >
            绑定微信
          </a>
          <Divider type="vertical" />
          <a
            onClick={() => {
              this.setPassword(record)
            }}
          >
            设置密码
          </a>
          <Divider type="vertical" />
          <a
            onClick={() => {
              this.update(record)
            }}
          >
            编辑
          </a>
          <Divider type="vertical" />
          <a
            onClick={() => {
              this.delete(record)
            }}
          >
            删除
          </a>
        </span>
      )
    }
  ]
  update = (record: any) => {
    this.setState({
      updateItem: record,
      modalOpen: true
    })
  }
  delete = (record: any) => {
    confirm({
      title: '确定删除？',
      content: '确定删除该项目？',
      onOk: () => {
        api.user.delete(Number(record.id)).then(res => {
          if (res.status === 200) {
            message.success('删除成功')
            this.getList()
          }
        })
      },
      onCancel() {}
    })
  }
  setPassword = (record: IUser) => {
    this.setState({
      passwordModalOpen: true,
      updateItem: record
    })
  }
  getList() {
    this.setState({
      loading: true
    })
    api.user.getTableData(this.state.form).then(res => {
      if (res.status === 200) {
        this.setState({
          list: res.data.rows,
          total: res.data.count,
          loading: false
        })
      }
    })
  }
  createClick = () => {
    this.setState({
      updateItem: {
        type: '员工',
        roleId: 3
      },
      modalTitle: '新建',
      modalOpen: true
    })
  }
  searchClick = () => {
    this.refresh()
  }
  refresh() {
    this.getList()
  }
  // 绑定小程序
  bingWeapp(user: IUser) {
    api.wechat.getQrCode(user.id.toString(), 'pages/index/index').then(res => {
      ImageView.show([
        {
          src: res.data,
          title: '扫码绑定'
        }
      ])
    })
  }
  componentWillMount() {
    this.getList()
  }
  render() {
    return (
      <div className={styles.index}>
        <Button
          type="primary"
          loading={this.state.loading}
          icon="sync"
          className={styles.refreshBtn}
          onClick={() => {
            this.refresh()
          }}
        >
          刷新
        </Button>
        <Form
          className={styles.form}
          labelCol={{
            span: 6
          }}
          wrapperCol={{
            span: 16
          }}
          layout="horizontal"
        >
          <Col span={8}>
            <Form.Item label="搜索词">
              <Input
                placeholder="请输入搜索词"
                onChange={e => {
                  this.setState({
                    form: {
                      page: this.state.form.page,
                      pageSize: this.state.form.pageSize,
                      keyword: e.target.value
                    }
                  })
                }}
              />
            </Form.Item>
          </Col>
        </Form>
        <Col span={24} className={styles.actionBtn}>
          <Button
            type="primary"
            htmlType="submit"
            icon="search"
            onClick={this.searchClick}
          >
            搜索
          </Button>
        </Col>
        <Col span={24} className={styles.addBtn}>
          <Button type="primary" icon="plus" onClick={this.createClick}>
            新建
          </Button>
        </Col>
        <Table
          bordered
          className={styles.table}
          columns={this.columns}
          dataSource={this.state.list}
          size="middle"
          rowKey="id"
          loading={this.state.loading}
          pagination={{
            position: 'bottom',
            pageSize: this.state.form.pageSize,
            total: this.state.total,
            pageSizeOptions: ['15', '30', '50'],
            current: this.state.form.page,
            showSizeChanger: true,
            onChange: (page, pageSize) => {
              const { form } = this.state
              form.page = page
              form.pageSize = pageSize ? pageSize : 1
              this.setState({
                form
              })
              this.getList()
            },
            showTotal: (total, range) => {
              return `共${total}条数据，当前显示${range}`
            },
            onShowSizeChange: (current, size) => {
              const { form } = this.state
              form.pageSize = size
              this.setState({
                form
              })
              this.getList()
            }
          }}
        />
        {this.state.modalOpen && (
          <DataModal
            title={this.state.modalTitle}
            onClose={() => {
              this.setState({ modalOpen: false })
            }}
            complete={() => {
              this.setState({ modalOpen: false })
              this.getList()
            }}
            updateItem={this.state.updateItem}
          />
        )}
        {this.state.passwordModalOpen && (
          <PasswordModal
            onClose={() => {
              this.setState({
                passwordModalOpen: false
              })
            }}
            complete={() => {
              message.success('设置成功')
              this.setState({
                passwordModalOpen: false
              })
              this.getList()
            }}
            updateItem={this.state.updateItem}
          />
        )}
      </div>
    )
  }
}

export default UserPage
